<template>
  <div class="w-100 d-flex flex-column align-items-center justify-content-center p-5 gap-5">
    <img :src="`${baseUrl}icons/no-notification.svg`" />
    <div class="text-center">
      <div class="fs-5 mb-2">{{ $t('flexigo.notifications.rider.noNotifications') }}</div>
      <div class="text-secondary">{{ $t('flexigo.notifications.rider.noNotificationsAltText') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'noNotification',
};
</script>
